/* eslint-disable no-unused-vars */
import axios from 'axios'
import { ReactElement, useEffect } from 'react'
import { Table } from 'react-bootstrap'
import { useDispatch } from 'react-redux'
import { DropdownWrapper, EditableDropdown, FlexWrapper, PageWrapper, SectionTitle, TableHeader, TableWrapper } from '../../../components'
import strings from '../../../locale/en'
import { dailyTestApi } from '../../../redux/test/api'
import { FormBackWrapper } from '../../admin/User/subcomponents'
import { TableRow } from '../CompletedSessions/subcomponents'

const DailyTest = (): ReactElement => {

    const { menu: {
        student: {
            dailyTest
        }
    } } = strings

    const dispatch = useDispatch()

    const getQuestion = (type: string, id: any) => {
        axios({
            method: 'POST',
            url: 'https://jlbb3ldr36.execute-api.ap-south-1.amazonaws.com/test_mock/test',
            data: {
                type: type,
                id: id
            },
            headers: {
                'content-type': 'application/json; charset=utf-8',
                Accept: 'application/json'
            }
        }).then(res => console.log(res)
        ).catch(err => console.log(err)
        )
    }

    useEffect(() => {
        // axios({
        //     method: 'POST',
        //     url: 'https://jlbb3ldr36.execute-api.ap-south-1.amazonaws.com/test_mock/test',
        //     data: {
        //         type: 'courses',
        //         id: ''
        //     },
        //     headers: { 
        //         'Access-Control-Allow-Origin': '*'
        //     }
        // }).then(res => console.log(res)
        // ).catch(err => console.log(err) 
        // )
        dispatch(dailyTestApi({
            type: 'courses',
            id: ''
        }))
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <PageWrapper>
            <FlexWrapper>
                <SectionTitle title={dailyTest} />
            </FlexWrapper>
            <FormBackWrapper>
                <FlexWrapper justifyContent='space-between'>
                    <DropdownWrapper>
                        <EditableDropdown
                            placeholder='Course'
                            isRequired
                            handleSelect={() => {
                                getQuestion('subjects', '')
                            }}
                            dropdownList={[]}
                        />
                    </DropdownWrapper>
                    <DropdownWrapper>
                        <EditableDropdown
                            placeholder='Subject'
                            isRequired
                            handleSelect={() => {
                                getQuestion('topics', '')
                            }}
                            dropdownList={[]}
                        />
                    </DropdownWrapper>
                    <DropdownWrapper>
                        <EditableDropdown
                            placeholder='Topic'
                            isRequired
                            handleSelect={() => {
                                getQuestion('questions', '')
                            }}
                            dropdownList={[]}
                        />
                    </DropdownWrapper>
                    <DropdownWrapper>
                        <EditableDropdown
                            placeholder='Sub Topic'
                            handleSelect={() => { }}
                            dropdownList={[]}
                        />
                    </DropdownWrapper>
                    <DropdownWrapper>
                        <EditableDropdown
                            placeholder='No of Questions'
                            handleSelect={() => { }}
                            dropdownList={[]}
                        />
                    </DropdownWrapper>
                </FlexWrapper>
                <FlexWrapper>
                    <TableWrapper>
                        <Table>
                            <TableHeader>
                                <TableRow>
                                </TableRow>
                            </TableHeader>
                            <tbody>
                                <TableRow>
                                </TableRow>
                            </tbody>
                        </Table>
                    </TableWrapper>
                </FlexWrapper>
            </FormBackWrapper>
        </PageWrapper>
    )
}

export default DailyTest 